<template>
	<form class="splash-controller" @submit.prevent="submit">
		<ManagingSection size="l" header="- 기본정보">
			<ManagingBox title="스플래시명" :isRequired="true">
				<input
					type="text"
					placeholder="스플래시 제목을 입력하세요"
					@input="singleMutation('title', $event.target.value)"
					:value="title"
				/>
				<p class="splash-controller__notice">
					내부 관리를 위한 제목 입력란입니다.(유저에게 미노출)
				</p>
			</ManagingBox>
			<ManagingBox title="노출기간" :isRequired="true">
				<RadioList
					:value="isReserved"
					:radio-list="isReservedList"
					key-name="value"
					value-name="name"
					@input="isReservedChange($event)"
				/>
				<DateRange
					v-if="isReserved === 1"
					:value="{ from: reservedFrom, to: reservedTo }"
					class="splash-controller__reserve-period"
					@input="dateChange"
				/>
			</ManagingBox>
		</ManagingSection>
		<ManagingSection size="l" header="- 연결정보">
			<ManagingBox title="시작팝업 연결여부">
				<RadioList
					:value="isConnectPopup"
					:radio-list="isConnectPopupList"
					key-name="value"
					value-name="name"
					@input="isConnectPopupChange($event)"
				/>
			</ManagingBox>
			<template v-if="!(isConnectPopup === 0 && !selectedPopup)">
				<ManagingBox title="시작팝업 선택">
					<StartPopupSearcher
						ref="StartPopupSearcher"
						:propValue="selectedPopupValue"
						:propSelectedPopup="selectedPopup"
						:imgWidthSize="20"
						imgWidthSizeUnit="%"
						@changeValue="
							singleMutation('selectedPopupValue', $event)
						"
						@changeItem="selectedPopupItemChange"
					/>
				</ManagingBox>
			</template>
		</ManagingSection>
		<ManagingSection
			v-for="typeItem in getAllTypeList"
			:key="typeItem.id"
			:header="typeItem.title"
			:isTable="true"
			:tableTitle="true"
		>
			<div
				class="splash-controller__table-wrap"
				v-for="(typeList, idx) in typeItem.list"
				:key="`${typeItem.id}-${idx}`"
			>
				<table class="table-main splash-controller__img-table">
					<thead>
						<tr>
							<th
								class="splash-controller__table__bar--top"
								:colspan="typeList.length"
							>
								{{ `${typeItem.os} 세트` }}
							</th>
						</tr>
						<tr>
							<th
								v-for="item in typeList"
								:key="item.id"
								:style="{ width: `${100 / typeList.length}%` }"
							>
								{{ item.label }}
							</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td
								v-for="item in typeList"
								:key="item.id"
								:class="{ 'has-img': item.src }"
							>
								<image-uploader
									group="splash"
									:image-size-limit="{
										width: item.w,
										height: item.h,
										previewWidth: 200,
										type: 'fit',
									}"
									:image-src="item.src"
									@upload="
										onImageUpload($event, {
											...item,
											os: typeItem.id,
										})
									"
								/>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</ManagingSection>
		<div class="btn-wrap-main">
			<button
				v-if="id"
				type="submit"
				class="btn-main blue"
				v-text="'저장'"
			/>
			<button
				v-else
				type="submit"
				class="btn-main blue"
				v-text="'등록'"
			/>
			<button class="btn-main blue bordered" type="button" @click="init">
				다시작성
			</button>
		</div>
	</form>
</template>

<script>
	import { mapState, mapGetters } from 'vuex';
	import moment from 'moment';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import DateRange from '@/components/DateRange';
	import RadioList from '@/components/RadioList';
	import StartPopupSearcher from '@/components/StartPopupSearcher.vue';
	import ImageUploader from '@/components/ImageUploader';

	export default {
		name: 'SplashController',
		components: {
			ManagingSection,
			ManagingBox,
			DateRange,
			RadioList,
			StartPopupSearcher,
			ImageUploader,
		},
		data() {
			return {
				tempImgArgs: null,
			};
		},
		computed: {
			...mapState('splash', [
				'id',
				'title',
				'isReservedList',
				'isReserved',
				'reservedFrom',
				'reservedTo',
				'isConnectPopup',
				'isConnectPopupList',
				'idPopup',
				'selectedPopup',
				'splashStatus',
				'selectedPopupValue',
			]),
			...mapGetters('splash', ['getAllTypeList']),
		},
		methods: {
			selectedPopupItemChange(item) {
				let idPopup = null;
				let selectedPopup = null;
				if (item) {
					idPopup = item.idPopup;
					selectedPopup = item;
				}
				this.$store.commit('splash/changeValues', [
					{ key: 'idPopup', value: idPopup },
					{ key: 'selectedPopup', value: selectedPopup },
				]);
			},
			isConnectPopupChange(newVal) {
				if (newVal === 0) {
					if (
						this.idPopup &&
						!confirm('연결한 시작팝업 정보가 초기화됩니다.')
					) {
						this.singleMutation('isConnectPopup', newVal);
						this.$nextTick(() => {
							this.singleMutation('isConnectPopup', 1);
						});
						return false;
					}
				}
				this.$store.commit('splash/changeValues', [
					{ key: 'idPopup', value: null },
					{ key: 'selectedPopup', value: null },
					{ key: 'isConnectPopup', value: newVal },
					{ key: 'selectedPopupValue', value: '' },
				]);
			},
			isReservedChange(newVal) {
				const changeList = [];
				if (newVal === 0) {
					changeList.push({ key: 'reservedFrom', value: '' });
					changeList.push({ key: 'reservedTo', value: '' });
				}
				changeList.push({ key: 'isReserved', value: newVal });
				this.$store.commit('splash/changeValues', changeList);
			},
			singleMutation(key, value) {
				this.$store.commit('splash/changeValues', [{ key, value }]);
			},
			onImageUpload(event, args) {
				this.$store.commit('splash/img', {
					...args,
					isDeleting: !event.fileDir,
					src: `${this.$store.state.env.IMAGE_STORAGE_PATH}${event.fileDir}/${event.fileSaveName}`,
				});
			},
			submit() {
				this.$store.dispatch('splash/post');
			},
			init() {
				this.$store.commit('splash/init');
			},
			dateChange({ from, to }) {
				this.$store.commit('splash/changeValues', [
					{ key: 'reservedFrom', value: from },
					{ key: 'reservedTo', value: to },
				]);
			},
		},
	};
</script>

<style lang="scss">
	.splash-controller {
		.splash-controller__table__bar--top {
			background: #dfe6ee;
		}

		.splash-controller__img-table {
			table-layout: fixed;

			tr {
				border-top: solid 1px #dfe6ee;
			}

			tbody {
				tr:hover {
					background-color: #fff;
				}

				td {
					vertical-align: top;
				}
			}
		}

		.splash-controller__table-wrap:first-of-type thead tr {
			border-top: none;
		}

		.splash-controller__reserve-period {
			margin: 12px 0 0 0;
		}

		.splash-controller__notice {
			margin-top: 10px;
		}
	}
</style>
